import React from 'react';
import AdminPanel from '../components/Admin/AdminPanel';

export default function Admin() {
  return <AdminPanel />;
}
